export const CONSTANTS = {
  RENEWAL_THRESHOLD_DAYS: 60,
  CIRCLE_RADIUS: 15.9155,
  DESKTOP_BREAKPOINT: 1024,
  DEFAULT_VEHICLE_TYPE: 'bike',
} as const

export const IMAGES = {
  BIKE_DESKTOP: {
    src: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Frame_2085662085_a6908d0424.webp',
    alt: 'bike',
    width: 512,
    height: 320,
  },
  BIKE_MOBILE: {
    src: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Car_1_f16ff5bf29.webp',
    alt: 'bike',
    width: 82,
    height: 82,
  },
} as const

export const TEXT = {
  HEADING: 'Renew your bike insurance\nin just *2 minutes*',
  AWARDS: ['Trusted by \n5 Cr+ Indians', 'Best direct \ninsurer 2025'],
  FORM_LABEL: 'Enter bike registration number',
  UID: 'UID: 7733 | T&Cs apply*',
} as const

export const VIDEO_DATA = {
  heading: '100% claim settlement is  most important to us when it comes to building trust',
  authorData: {
    authorName: 'Varun Dua',
    authorDesignation: 'Founder',
  },
  videoEventProps: {
    eventName: 'tap_btn_interaction',
    customProperties: {
      type: 'video_play_btn',
      journey: 'Video_Varun_Dua',
    },
  },
  videoSrcSet: {
    lg: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
    md: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
    sm: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
  },
  videoThumbnail: 'https://acko-cms.ackoassets.com/Varun_Dua_Video_thumbnail_8ea3c99b43.webp',
} as const

export const URLS = {
  HOME: '/',
} as const

export const ANALYTICS = {
  EVENTS: {
    VIEW_HOMEPAGE: 'view_homepage',
    TAP_RENEWAL_CARD: 'tap_btn_CTA_widget',
    TAP_CONTINUE_INSURE_CARD: 'tap_btn_CTA_widget',
  },
  PRODUCT: {
    BIKE: 'bike',
    AUTO_BIKE: 'auto-bike',
  },
  FUNNEL: {
    VISIT: 'visit',
    ENTRY: 'entry',
    CONTINUE_ENTRY: 'continue_entry',
    RENEWAL_ENTRY: 'renewal_entry',
  },
  HEADER_NAMES: 'Home',
  PAGE_TITLE: 'ACKO Insurance | Buy Car, Bike, Health & Travel Insurance Online | Welcome Change',
} as const

export const FORM = {
  PLACEHOLDER: 'e.g. KA01AB1234',
  BUTTON_TEXT: 'Check prices',
  ERROR_MESSAGE: 'Enter bike registration number',
  LOADING_TEXT: 'Processing...',
} as const

export const QUERY_PARAMS = {
  BIKE_NUMBER: 'bikeNumber',
  LEGACY_BIKE_NUMBER: 'carNumber',
} as const

export const ERROR_MESSAGES = {
  NO_RENEWAL_REDIRECT_URL: 'No redirect_url found in renewal plan data',
  NO_REDIRECT_LINK: 'No redirect_link found in recent search data',
} as const

export const DEFAULTS = {
  AUTO_SUBMIT: false,
} as const

export const API = {
  ENDPOINTS: {
    PROPOSAL_LIST: '/motororchestrator/api/v2/homepage/proposal_list',
    RENEWAL_PLANS: '/motororchestrator/api/v1/renewals/proposals/plans',
  },
} as const

export const EXPLORE_NEW_CARD = {
  TITLE: 'Insure your new bike at \n*zero commission*',
  DESCRIPTION: 'Save up to 80% on premiums',
  CTA: 'Explore new bike insurance',
  IMAGE: {
    src: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Scooter_1_88d418366c.webp',
    alt: 'bike image',
    height: 92,
    width: 110,
  },
  LINK: '/gi/bike-journey/mmv?flow=new',
} as const
